import $ from 'jquery'
import { closeModal } from '@/function/function.js';

export default {
    name: 'editer-analyse',
    components: {},
    props: [],
    data () {
        return {
        user_role: '',           //  Role d'un utilisateur

        analyze: {
            abreviation: null,
            nom: null,
            categorie_id: null,
            prix: null,
            technique_utilisee: null
        },
        savingCategory: false,
        categoryAnalyse:{
            nom: null
        },
        loading: false

        }
    },
    computed: {
        categoriesAnalyses() {
            return this.$store.getters['categoriesAnalyses']
        },
        
        analyse() {
            return this.$store.getters['analyse']
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },
    mounted () {
        setTimeout(() => {
        $('.shw').fadeIn()
        }, 500);

        this.$store.dispatch('getAnalyse',this.$route.params.id).then(
        () => {
            
            this.analyze.nom = this.analyse.nom
            this.analyze.abreviation = this.analyse.abreviation
            this.analyze.prix = this.analyse.prix
            this.analyze.categorie_id = this.analyse.categorie_id
            this.analyze.technique_utilisee = this.analyse.technique_utilisee

        }
        )

        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }
        this.$store.dispatch('getAllCategoriesAnalyses')

    },
    methods: {

        editAnalyse(){
            this.loading = true;

            let edit_data = {
                id: this.$route.params.id,
                data: this.analyze
            }
            this.$store.dispatch('editAnalyse', edit_data).then((response) => {
                if (response.success) {
                    this.successToast("Opération effectuée avec succès")
                    this.$router.push( { name: 'listeAnalyse' });
                } else {
                    if (response.code == 401) {
                        this.warningToast("Merci de renseigner le nom de l'analyse")
                    } else if (response.code == 409) {
                        this.warningToast("Cette analyse existe déjà !")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard")
                    }
                }
                this.loading = false;
            }).catch(() => {
                this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard")
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }
    }
}


